import { clsx } from 'clsx'
import { type VFC } from 'react'

import { PRICE_TYPES } from 'shared/consts/productTemplates'
import { getPriceForType } from 'shared/utils/productTemplateUtils'
import Price from 'views/components/atoms/Price'
import { type VariantState } from 'views/components/organisms/FilteredProductList/CompactProductListItem/index'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import {
  isDiscountValid,
  isListPriceGreaterThanOrEqualToRetailPrice,
} from 'views/utils/productUtils'

import './CompactProductListItemPrice.scss'

type CompactProductListItemPriceProps = {
  className?: string
  prescriptionMedicine: boolean
  variantState: VariantState
}

const CompactProductListItemPrice: VFC<
  CompactProductListItemPriceProps
> = props => {
  const { className, prescriptionMedicine, variantState } = props

  const { publicRuntimeConfig } = useShopAndRuntimeConfig()

  const { publicConfig } = publicRuntimeConfig

  const { discountBoundaries } = publicConfig

  const { bestOffer, discount, offerTypeSae, priceInfo } = variantState

  const listPrice = getPriceForType(priceInfo.prices, PRICE_TYPES.LIST)
  const retailPrice = getPriceForType(priceInfo.prices, PRICE_TYPES.RETAIL)

  return (
    <span className={clsx('o-CompactProductListItemPrice', className)}>
      <span>
        {!prescriptionMedicine &&
          isListPriceGreaterThanOrEqualToRetailPrice({
            listPrice,
            retailPrice,
          }) &&
          isDiscountValid(discount, discountBoundaries) && (
            <span className="o-CompactProductListItemPrice__list-price">
              {offerTypeSae ? (
                <Price {...listPrice} />
              ) : (
                bestOffer?.strike_price?.formatted
              )}
              <sup>{listPrice?.info?.index}</sup>
            </span>
          )}
        <span className="o-CompactProductListItemPrice__retail-price">
          <Price {...retailPrice} />
        </span>
      </span>
      <span className="o-CompactProductListItemPrice__unit-price">
        {priceInfo.unitPricing}
      </span>
    </span>
  )
}

export default CompactProductListItemPrice
